$bog_blitz_admin_question $mol_list
	question null
	number 0
	rows <= question_rows /
		<= Text_input $mol_string_button
			hint @ \Question...
			value? <=> question_text? \
		<= Header $mol_row
			sub /
				<= Number $mol_paragraph
					title <= number_title \
				<= Type_select $mol_select
					value? <=> question_type? \choice
					dictionary *
						choice @ \Choice
						text_input @ \Text Input
				<= Delete $mol_button_minor
					title @ \Delete
					click? <=> delete? null
		<= Options_section $mol_list
			rows <= option_rows /
		<= Add_option $mol_button_minor
			title @ \Add Option
			click? <=> add_option? null
		<= Correct_text_input $mol_string_button
			hint @ \Correct answer...
			value? <=> correct_text? \
	Image_section $mol_row
		sub <= image_section_content /
	Image_upload $mol_button_open
		title @ \Add Image
		files? <=> question_image_files? /
	Image_preview $mol_image
		uri <= question_image_uri \
	Image_remove $mol_button_minor
		title @ \Remove Image
		click? <=> remove_image? null
